import { apiClient } from '@/libs/axios';
import type { MutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export type UpdateAdminData = {
  name?: string;
  email?: string;
  password?: string;
  password_confirmed?: string;
  role_id?: string;
};

export type UpdateAdminParams = {
  id: string;
  data: UpdateAdminData;
};

export const updateAdmin = async ({
  id,
  data,
}: UpdateAdminParams): Promise<void> => {
  return await apiClient.patch(`admin/${id}`, data);
};

export function updateAdminMutationOptions(): MutationOptions<
  void,
  AxiosError,
  UpdateAdminParams
> {
  return {
    mutationFn: updateAdmin,
  };
}
